var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as StopoverHotelsActions from '../actions/stopover-hotels.actions';
import * as StopoverHotelsState from '../states/stopover-hotels.state';
var State = /** @class */ (function (_super) {
    __extends(State, _super);
    function State() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return State;
}(StopoverHotelsState.State));
export { State };
var initialState = StopoverHotelsState.initialState;
/**
 *
 *
 * @export
 * @param {*} [state=initialState]
 * @param {StopoverHotelsActions.Actions} action
 * @returns {StopoverHotelsState.State}
 */
export function reducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case StopoverHotelsActions.ActionTypes.LOADING:
            state = Object.assign({}, state, __assign({}, initialState, { loading: true }));
            return state;
        case StopoverHotelsActions.ActionTypes.PUT_FILTERS:
            state = Object.assign({}, state, { loading: false, filters: action.payload });
            return state;
        case StopoverHotelsActions.ActionTypes.PUT_HOTELS:
            state = Object.assign({}, state, { loading: false, hotels: action.payload });
            return state;
        case StopoverHotelsActions.ActionTypes.PUT_FEATURE_HOTELS:
            state = Object.assign({}, state, { loading: false, feature_hotels: action.payload });
            return state;
        case StopoverHotelsActions.ActionTypes.PUT_STOPOVER:
            state = Object.assign({}, state, { loading: false, stopover: action.payload });
            return state;
        case StopoverHotelsActions.ActionTypes.PUT_CITY_ID:
            state = Object.assign({}, state, { loading: false, city_id: action.payload['id'] });
            return state;
        case StopoverHotelsActions.ActionTypes.RESET:
            state = Object.assign({}, state, initialState);
            return state;
        default:
            return state;
    }
}
export var getLoading = function (state) { return state.loading; };
export var getHotels = function (state) { return state.hotels; };
export var getFeatureHotels = function (state) { return state.feature_hotels; };
export var getFilters = function (state) { return state.filters; };
export var getStopover = function (state) { return state.stopover; };
export var getCityId = function (state) { return state.city_id; };
